import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  dialog: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: 55,
    },
  },
  dialogContent: {
    width: '70vw',
    maxWidth: '100%',
    height: '70dvh',
    padding: '0px',
    overflowX: 'hidden',
    backgroundColor: theme.palette.paper.secondary,
    [theme.breakpoints.down('sm')]: {
      minWidth: '100px',
      width: '90vw',
      height: '60dvh',
    },
  },
  closeIcon: {
    color: theme.palette.base.red,
  },
}))

export default styles
